import {useTranslation} from "../contexts/TranslationContext";
import img1 from "../images/image 1.png"
import img2 from "../images/image 2.png"
import img3 from "../images/image 3.png"
const WhoWillUseSapioo = () => {
  const {t} = useTranslation();
  return <section className={'pt-6 pb-24'}>
    <div className={'container mx-auto px-4'}>
      <h2 className={'text-2xl font-bold mb-10'}>
        {t('whoWillUseSapioo')}
      </h2>
      <div className={'grid gap-9 sm:grid-cols-2 xl:grid-cols-4'}>
        <div className={'border flex flex-col justify-between rounded-2xl pt-3 pb-8 px-4'}>
          <img src={img1} className={'w-[80%] mx-auto'} alt={t('organizationForCertification')}/>
          <h4 className={'text-sm text-center'}>
            {t('organizationForCertification')}
          </h4>
        </div>
        <div className={'border flex flex-col justify-between rounded-2xl pt-3 pb-8 px-4'}>
          <img src={img2} className={'w-[80%] mx-auto'} alt={t('insuranceCompanies')}/>
          <h4 className={'text-sm text-center'}>
            {t('insuranceCompanies')}
          </h4>
        </div>
        <div className={'border flex flex-col justify-between rounded-2xl pt-3 pb-8 px-4'}>
          <img src={img3} className={'w-[80%] mx-auto'} alt={t('grantApplications')}/>
          <h4 className={'text-sm text-center'}>
            {t('grantApplications')}
          </h4>
        </div>
        <div className={'border flex flex-col justify-between rounded-2xl pt-3 pb-8 px-4'}>
          <span className={'w-[80%] text-6xl text-center font-bold block m-auto'}>{t('and')}</span>
          <h4 className={'text-sm text-center'}>
            {t('andManyOtherCompanies')}
          </h4>
        </div>
      </div>


    </div>
  </section>
}
export default WhoWillUseSapioo;